export default __webpack_public_path__ + "static/media/ic_svc_blockchain_wallet.70327c5d.png";